if (!customElements.get('dbtfy-scrolling-banner')) {
  class DbtfyScrollingBanner extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('ul.scrolling_banner_inner');
      if (!this.list) return;

      if (!this.baseItems) {
        this.baseItems = Array.from(this.list.children).map((item) => item.cloneNode(true));
      }

      this.onResize = this.onResize || (() => this.scheduleRebuild(150));
      this.onFontsLoaded = this.onFontsLoaded || (() => this.scheduleRebuild(0));
      window.addEventListener('resize', this.onResize, { passive: true });

      if (document.fonts && document.fonts.addEventListener) {
        document.fonts.addEventListener('loadingdone', this.onFontsLoaded);
        document.fonts.ready.then(() => {
          if (this.isConnected) this.scheduleRebuild(0);
        });
      }

      this.rebuild();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (document.fonts && document.fonts.removeEventListener) {
        document.fonts.removeEventListener('loadingdone', this.onFontsLoaded);
      }
      window.clearTimeout(this.rebuildTimer);
      if (this.animationStyle) this.animationStyle.remove();
      this.animationStyle = null;
    }

    scheduleRebuild(delay) {
      window.clearTimeout(this.rebuildTimer);
      this.rebuildTimer = window.setTimeout(() => this.rebuild(), delay);
    }

    rebuild() {
      if (!this.isConnected || !this.list || !this.baseItems || !this.baseItems.length) return;

      this.list.replaceChildren(...this.baseItems.map((item) => item.cloneNode(true)));
      const setWidth = Math.ceil(this.list.getBoundingClientRect().width);
      const viewportWidth = Math.ceil(this.getBoundingClientRect().width || window.innerWidth);
      if (!setWidth || !viewportWidth || !this.list.getClientRects().length) return;

      const copies = Math.max(1, Math.ceil(viewportWidth / setWidth));
      for (let index = 0; index < copies; index += 1) {
        this.baseItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          this.list.appendChild(clone);
        });
      }

      const sectionId = (this.dataset.sectionId || 'banner').replace(/[^a-zA-Z0-9_-]/g, '-');
      const animationName = 'dbtfy-scrolling-banner-loop-' + sectionId;
      const reverse = this.dataset.marqueeDirection === 'right' || this.dataset.marqueeDirection === 'normal';
      const keyframes = reverse
        ? '@keyframes ' + animationName + ' { from { transform: translateX(-' + setWidth + 'px); } to { transform: translateX(0); } }'
        : '@keyframes ' + animationName + ' { from { transform: translateX(0); } to { transform: translateX(-' + setWidth + 'px); } }';

      if (!this.animationStyle) {
        this.animationStyle = document.createElement('style');
        this.animationStyle.id = 'dbtfy-scrolling-banner-style-' + sectionId;
        document.head.appendChild(this.animationStyle);
      }
      this.animationStyle.textContent = keyframes;

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.list.style.animation = 'none';
        return;
      }

      const duration = Math.max(1, Number(this.dataset.animationDuration) || 32);
      this.list.style.animationName = animationName;
      this.list.style.animationDuration = duration + 's';
      this.list.style.animationIterationCount = 'infinite';
      this.list.style.animationTimingFunction = 'linear';
    }
  }

  customElements.define('dbtfy-scrolling-banner', DbtfyScrollingBanner);
}
